export default {
  name: 'product_selection',
  component_path: 'modules/procedures/blocks/order/BlockProducts'
}